import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import { Head, Nav, Footer } from '@components';
import { GlobalStyle, theme } from '@styles';

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  #content {
    flex: 1 0 auto;
  }
`;

const Layout = ({ children, location, title, description }) => {
  const isHome = location.pathname === '/';

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.substring(1);
      const timeout = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView();
          el.focus();
        }
      }, 0);
      return () => clearTimeout(timeout);
    }
  }, [location.hash]);

  useEffect(() => {
    const allLinks = Array.from(document.querySelectorAll('a'));
    allLinks.forEach(link => {
      if (link.host && window.location.host && link.host !== window.location.host) {
        link.setAttribute('rel', 'noopener noreferrer');
        link.setAttribute('target', '_blank');
      }
    });
  }, []);

  return (
    <>
      <Head title={title} description={description} />

      <div id="root">
        <ThemeProvider theme={theme}>
          <GlobalStyle />

          <a className="skip-to-content" href="#content">
            Перейти к содержимому
          </a>

          <StyledContent>
            <Nav isHome={isHome} pathname={location.pathname} />
            <div id="content">
              {children}
              <Footer />
            </div>
          </StyledContent>
        </ThemeProvider>
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.object.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
};

Layout.defaultProps = {
  title: null,
  description: null,
};

export default Layout;
